module.exports = __webpack_public_path__ + "img/CFX-banner.81a2b555.png";